import { render, staticRenderFns } from "./_algoliaHighlight.vue?vue&type=template&id=0901b0b2"
import script from "./_algoliaHighlight.vue?vue&type=script&lang=js"
export * from "./_algoliaHighlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports